export default __webpack_public_path__ + "img/allergy-eggs.333b92b85775c0e0bdc4f38473bff6b6.svg";